import { Paragraph, TextRun } from 'docx'
import { ProcessingContext } from '../types'

/**
 * Process blockquote lines and return paragraph or null
 */
export function processBlockquote(
  trimmedLine: string,
  context: ProcessingContext
): Paragraph | null {
  if (trimmedLine.startsWith('>')) {
    const quoteText = trimmedLine.replace(/^>\s*/, '')
    return new Paragraph({
      children: [new TextRun({ 
        text: quoteText, 
        italics: true,
        size: context.fontSize,
        font: context.font,
        color: '000000'
      })],
      spacing: { before: 120, after: 120 }
    })
  }
  return null
}